import React, { createContext, useCallback, useState } from 'react'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'
import { postQuestionnaireRequest } from 'components/QuestionnaireRequestAutomated/api/processor'
import {
  archiveQuestionnaire,
  selectCurrentStatus,
  updateCurrentStatus,
  updateStatuses,
} from '../../slices/globalSlice'
import CompletedModal from '../../modal/completedModal'
import SubmitCautionModal from '../../modal/submitCautionModal'
import AutomatedTasks from './AutomatedTasks'
import ManualTasks from './ManualTasks'

export const TasksSectionContext = createContext()

export default function TasksSection({ initialAttachments }) {
  const dispatch = useDispatch()
  const currentStatus = useSelector(selectCurrentStatus)
  const hashedId = useSelector((state) => state.global.hashedId)
  const purchaserToken = useSelector((state) => state.global.purchaserToken)
  const workflowType = useSelector((state) => state.global.workflowType)
  const respondedFiles = useSelector((state) => state.global.respondingFiles)

  const [openCompletedModal, setOpenCompletedModal] = useState(false)
  const [sending, setSending] = useState(false)
  const [openSubmitCautionModal, setOpenSubmitCautionModal] = useState(false)

  const canSendRequest =
    (currentStatus === 'email sent' || currentStatus === 'paid') &&
    (workflowType === 'automated' || (workflowType === 'manual' && respondedFiles.length > 0))
  const hasSentRequest = currentStatus === 'email sent'

  const submitRequest = async () => {
    if (sending) return

    try {
      setSending(true)
      const res = await postQuestionnaireRequest(hashedId)
      dispatch(updateStatuses(res.data?.statuses))
      dispatch(updateCurrentStatus(res.data?.current_status))

      setOpenSubmitCautionModal(false)
      setOpenCompletedModal(true)
    } catch (e) {
      console.error(e)
    } finally {
      setSending(false)
    }
  }

  const renderTasks = useCallback(() => {
    if (workflowType === 'manual') {
      return <ManualTasks />
    }

    if (workflowType === 'automated') {
      return <AutomatedTasks />
    }

    return null
  }, [workflowType])

  return (
    <div className="dome-d-flex dome-flex-column dome-gap12">
      <span className="dome-h3 dome-color-darkest-grey">your tasks</span>
      <TasksSectionContext.Provider value={{ initialAttachments }}>{renderTasks()}</TasksSectionContext.Provider>
      <button
        type="button"
        disabled={!canSendRequest}
        onClick={() => setOpenSubmitCautionModal(true)}
        className={clsx('dome-btn dome-btn-base', canSendRequest ? 'dome-btn-green-stroke' : 'dome-btn-disabled')}
      >
        {hasSentRequest ? 're-send' : 'send'}
      </button>
      <SubmitCautionModal
        open={openSubmitCautionModal}
        onSubmit={() => {
          submitRequest()
        }}
        submitting={sending}
        onClose={() => setOpenSubmitCautionModal(false)}
      />
      <CompletedModal
        open={openCompletedModal}
        onClose={() => setOpenCompletedModal(false)}
        onCancel={() => (window.location = '/questionnaire_requests/list')}
        onSubmit={() => {
          setOpenCompletedModal(false)
          dispatch(archiveQuestionnaire({ questionnaireRequestId: hashedId, purchaserToken }))
        }}
      />
    </div>
  )
}
